/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $NavigationRailItem = {
    type: 'one-of',
    contains: [],
};